import pluralize from 'pluralize';

exports.sanitizeEntityObjectiveLabelCode = (entityObjectiveLabelCode) => {
    if (!entityObjectiveLabelCode || entityObjectiveLabelCode === '') {
        return '';
    }
    return pluralize.singular(entityObjectiveLabelCode);
};

exports.getCapitalizedSingular = term => pluralize.singular(term).replace(/^\w/, c => c.toUpperCase());

exports.getCapitalizedPlural = term => pluralize.plural(term).replace(/^\w/, c => c.toUpperCase());

exports.generateLabelCodePreview = (term) => {
    if (!term) {
        return '';
    }
    const singular = exports.getCapitalizedSingular(term);
    const plural = exports.getCapitalizedPlural(term);

    return `Preview: ${singular}, ${plural}, Cost per ${singular}`;
};



// WEBPACK FOOTER //
// ./src/helpers/labelCode.js